<script setup>

</script>

<template>
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_514_1020)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0610352 3.90414L3.78217 7.62527L0.0610352 11.3464L3.90417 15.2505L11.5294 7.62527L3.90417 0L0.0610352 3.90414Z" fill="#376FFE"/>
    </g>
    <defs>
      <clipPath id="clip0_514_1020">
        <rect width="11.5904" height="15.2505" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss">

</style>
